<script lang="ts" setup>
import type { ResponsiveImageType } from "vue-datocms";
import type { MagazineSectionRecord } from "~~/server/graphql/datocms/generated";
import { Image as DatocmsImage } from "vue-datocms";

defineProps<{ data: MagazineSectionRecord }>();
</script>

<template>
  <div class="mb-3xl lg:mb-5xl relative">
    <VectorWithStroke class="vector-with-stroke--background right-lg md:right-3xl absolute -bottom-6 z-10 h-[54px] w-[52px]" />

    <div class="full-bleed overflow-hidden bg-linear-to-b from-[#f7d652] to-[#EAB732]">
      <div class="container relative mx-auto">
        <div class="px-lg py-3xl">
          <Vector class="vector--background absolute bottom-[-185px] left-[-260px] z-0 h-[354px] w-[340px] rotate-0 md:bottom-[-100px]" />
          <Vector class="vector--background top-2xl absolute right-[-100px] z-0 h-[354px] w-[340px] rotate-10 md:top-[-100px]" />

          <div class="relative z-20">
            <div class="flex flex-col md:flex-row-reverse">
              <div class="mb-xl self-center md:mb-0 md:basis-1/2">
                <a v-if="data.item.image" :href="data.item.url" target="_blank" class="block md:max-w-[400px]">
                  <DatocmsImage v-if="data.item.image" :data="data.item.image.responsiveImage as ResponsiveImageType" />
                </a>
              </div>

              <div class="self-center md:basis-1/2">
                <h6 v-if="data.item.optExtraTitle" class="mb-xs font-normal text-neutral-600">
                  {{ data.item.optExtraTitle }}
                </h6>
                <h3 class="mb-xs">
                  {{ data.item.title }}
                </h3>
                <p v-if="data.item.optText" class="mb-lg text-balance">
                  {{ data.item.optText }}
                </p>
                <div class="flex justify-start">
                  <UButton variant="solid" color="primary" size="xl" :ui="{ base: 'leading-7' }" :to="data.item.url" target="_blank">
                    {{ data.item.linkText }}
                  </UButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.vector--background {
  --esc-vector-fill-color: #00000066;
}
.vector-with-stroke--background {
  --esc-vector-fill-color: #eab732;
  --esc-vector-opacity: 1;
  --esc-vector-mix-blend-mode: normal;
}
</style>
